
import base from './base'; // 导入接口域名列表
import axios from '@/axios'; // 导入axios实例
import qs from 'qs';
const baseUrl = base.default;

const obj = {
    //获取省市区地址数据
    getAllArea(params) {
        return axios.post(`${baseUrl}/location/getAllArea`,qs.stringify(params));
    },
    //查询一级专业
    selectFirstDic(params){
        return axios.post(`${baseUrl}/dictionary/selectFirstDic`,qs.stringify(params));
    },
    //查询二级专业(未使用)
    selectSecondDic(params){
        return axios.post(`${baseUrl}/artmap2/selectSecondDic`,qs.stringify(params));
    },
    //申请开通工作室
    addStudioApplyDetailNoLogin(params){
        return axios.post(`${baseUrl}/artmapOfStudioEvaluation/addStudioApplyDetailNoLogin`,qs.stringify(params));
    },
    //根据手机号查询工作室信息
    selectStudioInfoByMobile(params){
        return axios.post(`${baseUrl}/artmapOfStudioEvaluation/selectStudioInfoByMobile`,qs.stringify(params));
    },
    //老师申请
    addTeacherApplyNoLogin(params){
        return axios.post(`${baseUrl}/teacherApply/addTeacherApplyNoLogin`,qs.stringify(params));
    },
    //老师培训申请
    addTeacherApplyNoLoginForTraining(params){
        return axios.post(`${baseUrl}/teacherApply/addTeacherApplyNoLoginForTraining`,qs.stringify(params));
    },
    
    //根据手机号查询用户信息
    selectUserInfoByMobile(params){
        return axios.post(`${baseUrl}/teacherApply/selectUserInfoByMobile`,qs.stringify(params));
    },
    
    //获取老师认证标签
    getSysDictByIdentityLabel(params) {
        return axios.get(`${baseUrl}/teacherApply/getSysDictByIdentityLabel`, {params:params});
    }, 
    //获取可用的培训标签
    getSysDictByTrainingLabel(params){
        return axios.get(`${baseUrl}/teacherApply/getSysDictByTrainingLabel`, {params:params});
    },

    //查询证书
    getLatestReport(params){
        return axios.post(`${baseUrl}/assessment/report/getLatestReport`,qs.stringify(params));
    },

    //获取工作室等级名称
    getStudioLevels(params){
        return axios.post(`${baseUrl}/sysDict/getStudioLevels`,qs.stringify(params));
    },
    
    //获取临时安全令牌带有签名和回调
    ossUploadGetSecurityTokenWithSign(params){
        return axios.post(`${baseUrl}/ossUpload/getSecurityTokenWithSignNotLogin`,qs.stringify(params));
    },

    //根据token获取登录信息
    getLoginInfo(params,errorNotTips){
        //return axios.post(`/test/ArtAppWebServer/rest/user/getLoginInfo`,qs.stringify(params));
        return axios({
            method: 'post',
            //url: `/test/ArtAppWebServer/rest/user/getLoginInfo`,
            url: `${baseUrl}/login/getLoginInfo`,
            params: params,
            headers: {
                'errorNotTips':errorNotTips
            }
        })
    },

    //获取用户实名信息
    getRealNameInfo(params,errorNotTips){
        //return axios.post(`${baseUrl}/user/getRealNameInfo`,qs.stringify(params));
        return axios({
            method: 'post',
            url: `${baseUrl}/user/getRealNameInfo`,
            params: params,
            headers: {
                'errorNotTips':errorNotTips
            }
        })
    },

    //登出
    logout(params){
        return axios.post(`${baseUrl}/login/logout`,qs.stringify(params));
    },
    //根据共享行动单位号查询机构id
    getStudioIdByStudioAllianceNo(params){
        return axios.post(`${baseUrl}/communityCourse/getStudioIdByStudioAllianceNo`,qs.stringify(params));
    },

}

export default obj;

